/**
 * Mapa centralizado de ícones para meios de pagamento
 * 
 * Associa cada tipo de pagamento ao componente de ícone correspondente.
 * Usa ícones SVG customizados (Pix, Boleto) e Lucide para os demais.
 */

import React from 'react';
import { PixIcon } from './PixIcon';
import { BoletoIcon } from './BoletoIcon';
import {
  CreditCard,
  Banknote,
  Landmark,
  BookOpen,
  FileText,
  ScrollText,
  Package,
  HelpCircle,
} from 'lucide-react';
import { cn } from '@/lib/utils';

/** Tipo das props aceitas por cada ícone de pagamento */
interface PaymentIconProps {
  className?: string;
}

/**
 * Wrapper para ícones Lucide padronizarem a interface
 * com os ícones SVG customizados
 */
function wrapLucide(Icon: React.FC<any>): React.FC<PaymentIconProps> {
  return function WrappedIcon({ className }: PaymentIconProps) {
    return <Icon className={cn('h-6 w-6', className)} />;
  };
}

/**
 * Mapa de tipo de pagamento → componente de ícone
 * 
 * Chaves correspondem aos valores de TipoPagamento
 * definidos em useFinanceiroMeiosPagamento.ts
 */
export const PaymentMethodIcon: Record<string, React.FC<PaymentIconProps>> = {
  pix: PixIcon,
  indefinido: wrapLucide(HelpCircle),
  boleto: BoletoIcon,
  cartao_credito: wrapLucide(CreditCard),
  cartao_debito: wrapLucide(CreditCard),
  dinheiro: wrapLucide(Banknote),
  ted: wrapLucide(Landmark),
  doc: wrapLucide(Landmark),
  carne: wrapLucide(BookOpen),
  cheque: wrapLucide(FileText),
  nota_promissoria: wrapLucide(ScrollText),
  outros: wrapLucide(Package),
};

/**
 * Ícone fallback para tipos de pagamento não mapeados
 */
export const DefaultPaymentIcon = wrapLucide(Package);
